import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  submit(event) {
    if (this.submitting) {
      event.preventDefault()
      return
    }

    event.preventDefault()
    this.submitting = true
    this.element.querySelectorAll("button[type=submit], input[type=submit]").forEach(button => {
      button.disabled = true
      if (!button.dataset.submittingLabel) return

      if (button.tagName === "BUTTON") {
        button.textContent = button.dataset.submittingLabel
      } else {
        button.value = button.dataset.submittingLabel
      }
    })

    HTMLFormElement.prototype.submit.call(this.element)
  }
}
